import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import( '../views/login/login.vue' ) //登录
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/user.vue')
  },
    // 测评开始
  {
    path: '/evaluationStart',
    name: 'evaluationStart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/evaluation/evaluationStart.vue')
  } ,
  {
    path: '/question',
    name: 'question',
    component: () => import(/* webpackChunkName: "about" */ '@/views/evaluation/question.vue')
  },
  {
    path: '/course',
    name: 'course',
    component: () => import(/* webpackChunkName: "about" */ '@/views/evaluation/course.vue')
  } ,
  {
    path: '/courseStart',
    name: 'courseStart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/evaluation/courseStart.vue')
  } ,
]

const router = new VueRouter({
  routes
})

export default router
